var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ObraService } from '../../../services/obraService';
import { ReferenciaObraService } from '../../../services/referenciaObraService';
import { FaseService } from '../../../services/faseService';
import { EstadoObraService } from '../../../services/estadoObraService';
import { TipoObraService } from '../../../services/tipoObraService';
import { EmpresaService } from '../../../services/empresaService';
export var ObrasListaMixin = {
    data: function () {
        return {
            perPage: 10,
            currentPage: 1,
            filtros: {
                busqueda: '',
                estado: null,
                tipo: null,
                fase: null
            },
            obras: [],
            referenciasObras: [],
            fases: [],
            estadosObras: [],
            tiposObras: [],
            empresas: [],
            cargando: false
        };
    },
    computed: {
        obrasFiltradas: function () {
            var _this = this;
            var filtradas = this.obras;
            // Filtro de búsqueda
            if (this.filtros.busqueda) {
                var busqueda_1 = this.filtros.busqueda.toLowerCase();
                filtradas = filtradas.filter(function (obra) {
                    return obra.direccion.toLowerCase().includes(busqueda_1) ||
                        obra.municipio.toLowerCase().includes(busqueda_1) ||
                        obra.provincia.toLowerCase().includes(busqueda_1) ||
                        (obra.nombreEmpresa && obra.nombreEmpresa.toLowerCase().includes(busqueda_1)) ||
                        (obra.descripcion && obra.descripcion.toLowerCase().includes(busqueda_1));
                });
            }
            // Filtro por estado
            if (this.filtros.estado) {
                filtradas = filtradas.filter(function (obra) { return obra.idEstadoObra === _this.filtros.estado; });
            }
            // Filtro por tipo
            if (this.filtros.tipo) {
                filtradas = filtradas.filter(function (obra) { return obra.idTipoObra === _this.filtros.tipo; });
            }
            // Filtro por fase
            if (this.filtros.fase) {
                filtradas = filtradas.filter(function (obra) { return obra.idFase === _this.filtros.fase; });
            }
            return filtradas;
        },
        opcionesEstado: function () {
            return this.estadosObras.map(function (estado) { return ({
                value: estado.idEstadoObra,
                text: estado.nombre
            }); });
        },
        opcionesTipo: function () {
            return this.tiposObras.map(function (tipo) { return ({
                value: tipo.idTipoObra,
                text: tipo.nombre
            }); });
        },
        opcionesFase: function () {
            return this.fases.map(function (fase) { return ({
                value: fase.idFase,
                text: fase.nombre
            }); });
        }
    },
    mounted: function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cargarCatalogos()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.cargarObras()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    methods: {
        cargarObras: function () {
            return __awaiter(this, void 0, Promise, function () {
                var _a, error_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.cargando = true;
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, 4, 5]);
                            _a = this;
                            return [4 /*yield*/, ObraService.getAll()];
                        case 2:
                            _a.obras = _b.sent();
                            return [3 /*break*/, 5];
                        case 3:
                            error_1 = _b.sent();
                            console.error('Error cargando obras:', error_1);
                            this.$toast({
                                component: { template: '<div>Error al cargar las obras</div>' },
                                props: { variant: 'danger' },
                            });
                            return [3 /*break*/, 5];
                        case 4:
                            this.cargando = false;
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        cargarCatalogos: function () {
            return __awaiter(this, void 0, Promise, function () {
                var error_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, Promise.all([
                                    this.obtenerReferenciasObras(),
                                    this.obtenerFases(),
                                    this.obtenerEstadosObras(),
                                    this.obtenerTiposObras(),
                                    this.obtenerEmpresas()
                                ])];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            error_2 = _a.sent();
                            console.error('Error cargando catálogos:', error_2);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        obtenerReferenciasObras: function () {
            return __awaiter(this, void 0, Promise, function () {
                var referencias, error_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, ReferenciaObraService.getAll()];
                        case 1:
                            referencias = _a.sent();
                            this.referenciasObras = referencias.sort(function (a, b) { return a.nombre.localeCompare(b.nombre); });
                            return [2 /*return*/, this.referenciasObras];
                        case 2:
                            error_3 = _a.sent();
                            console.error('Error cargando referencias de obras:', error_3);
                            return [2 /*return*/, []];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        obtenerFases: function () {
            return __awaiter(this, void 0, Promise, function () {
                var fases, error_4;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, FaseService.getAll()];
                        case 1:
                            fases = _a.sent();
                            this.fases = fases.sort(function (a, b) { return a.nombre.localeCompare(b.nombre); });
                            return [2 /*return*/, this.fases];
                        case 2:
                            error_4 = _a.sent();
                            console.error('Error cargando fases:', error_4);
                            return [2 /*return*/, []];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        obtenerEstadosObras: function () {
            return __awaiter(this, void 0, Promise, function () {
                var estados, error_5;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, EstadoObraService.getAll()];
                        case 1:
                            estados = _a.sent();
                            this.estadosObras = estados.sort(function (a, b) { return a.nombre.localeCompare(b.nombre); });
                            return [2 /*return*/, this.estadosObras];
                        case 2:
                            error_5 = _a.sent();
                            console.error('Error cargando estados de obras:', error_5);
                            return [2 /*return*/, []];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        obtenerTiposObras: function () {
            return __awaiter(this, void 0, Promise, function () {
                var tipos, error_6;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, TipoObraService.getAll()];
                        case 1:
                            tipos = _a.sent();
                            this.tiposObras = tipos.sort(function (a, b) { return a.nombre.localeCompare(b.nombre); });
                            return [2 /*return*/, this.tiposObras];
                        case 2:
                            error_6 = _a.sent();
                            console.error('Error cargando tipos de obras:', error_6);
                            return [2 /*return*/, []];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        obtenerEmpresas: function () {
            return __awaiter(this, void 0, Promise, function () {
                var empresas, error_7;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, EmpresaService.getAll()];
                        case 1:
                            empresas = _a.sent();
                            this.empresas = empresas.sort(function (a, b) { return a.nombre.localeCompare(b.nombre); });
                            return [2 /*return*/, this.empresas];
                        case 2:
                            error_7 = _a.sent();
                            console.error('Error cargando empresas:', error_7);
                            return [2 /*return*/, []];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        getEstadoVariant: function (estado) {
            var variants = {
                'En Progreso': 'primary',
                'Completada': 'success',
                'Pendiente': 'warning',
                'Cancelada': 'danger',
                'Pausada': 'secondary'
            };
            return variants[estado] || 'secondary';
        },
        formatearFecha: function (fecha) {
            if (!fecha)
                return '-';
            return new Date(fecha).toLocaleDateString('es-ES');
        },
        filtrarObras: function () {
            this.currentPage = 1;
        },
        limpiarFiltros: function () {
            this.filtros = {
                busqueda: '',
                estado: null,
                tipo: null,
                fase: null
            };
            this.currentPage = 1;
        },
        nuevaObra: function () {
            this.$router.push({ name: 'obras-nueva' });
        },
        verObra: function (id) {
            this.$router.push({ name: 'obras-detalle', params: { id: id.toString() } });
        },
        editarObra: function (id) {
            this.$router.push({ name: 'obras-editar', params: { id: id.toString() } });
        },
        eliminarObra: function (id) {
            return __awaiter(this, void 0, Promise, function () {
                var error_8, statusCode, responseData, errorMessage;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 4, , 5]);
                            return [4 /*yield*/, this.$swal({
                                    title: '¿Estás seguro?',
                                    text: 'Esta obra será eliminada permanentemente',
                                    icon: 'warning',
                                    showCancelButton: true,
                                    confirmButtonText: 'Sí, eliminar',
                                    cancelButtonText: 'Cancelar',
                                })];
                        case 1:
                            _c.sent();
                            return [4 /*yield*/, ObraService.delete(id)
                                // Recargar la lista
                            ];
                        case 2:
                            _c.sent();
                            // Recargar la lista
                            return [4 /*yield*/, this.cargarObras()];
                        case 3:
                            // Recargar la lista
                            _c.sent();
                            this.$toast.success('Obra eliminada correctamente');
                            return [3 /*break*/, 5];
                        case 4:
                            error_8 = _c.sent();
                            if (error_8 === 'cancel') {
                                return [2 /*return*/]; // Usuario canceló
                            }
                            statusCode = (_a = error_8 === null || error_8 === void 0 ? void 0 : error_8.response) === null || _a === void 0 ? void 0 : _a.status;
                            responseData = (_b = error_8 === null || error_8 === void 0 ? void 0 : error_8.response) === null || _b === void 0 ? void 0 : _b.data;
                            // Si el backend devuelve un 409 (Conflict), es un error de integridad de datos
                            if (statusCode === 409) {
                                errorMessage = null;
                                if (responseData) {
                                    if (typeof responseData === 'string') {
                                        errorMessage = responseData;
                                    }
                                    else if (responseData.message) {
                                        errorMessage = responseData.message;
                                    }
                                    else if (responseData.error) {
                                        errorMessage = responseData.error;
                                    }
                                }
                                // Si no se encontró mensaje, usar el mensaje por defecto
                                if (!errorMessage) {
                                    errorMessage = 'No se puede eliminar la obra porque tiene registros asociados. Por favor, elimine primero los registros relacionados.';
                                }
                                this.$toast.error(errorMessage);
                            }
                            else if (statusCode === 404) {
                                this.$toast.error('La obra no existe o ya ha sido eliminada');
                            }
                            else {
                                console.error('Error eliminando obra:', error_8);
                                this.$toast.error('Error al eliminar la obra');
                            }
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
    }
};
